export const PRIVACY_POLICY_URL = "https://www.kago.digital/privacy-policy/";

export const OPT_IN_DISCLAIMER_FIELDS = [
  {
    name: "optInEventCommunications",
    label:
      "I agree to receive event-related communications from Kago Events, including updates before, during, and after the event (such as reminders, schedule changes, and follow-ups).",
    question_type: "checkbox",
    list: [],
    isSystem: true,
    required: true,
  },
  {
    name: "optInWhatsAppCommunications",
    label:
      "I consent to receive event-related communications via WhatsApp, which is operated by Meta Platforms. I understand that my phone number will be used for this purpose and that I can opt out at any time.",
    question_type: "checkbox",
    list: [],
    isSystem: true,
    required: true,
  },
  {
    name: "privacyPolicyAcknowledgment",
    label: "By registering, you agree to our Privacy Policy.",
    question_type: "privacy_disclaimer",
    linkUrl: PRIVACY_POLICY_URL,
    list: [],
    isSystem: true,
    required: false,
  },
];

export const isSystemDisclaimerField = (field) =>
  field?.isSystem === true ||
  field?.name?.startsWith("optIn") ||
  field?.question_type === "privacy_disclaimer";

export const appendOptInDisclaimerFields = (fields) => {
  const userFields = fields.filter((f) => !isSystemDisclaimerField(f));
  return [...userFields, ...OPT_IN_DISCLAIMER_FIELDS];
};

export const validateRequiredCheckboxes = (fields, values) => {
  const errors = {};
  fields.forEach((field) => {
    if (field.question_type === "checkbox" && field.required && !values[field.name]) {
      errors[field.name] = "This consent is required";
    }
  });
  return errors;
};

export const mapCustomFieldValues = (fields, values) =>
  fields
    .filter((field) => field.question_type !== "privacy_disclaimer")
    .map((field) => ({
      label: field.label,
      value:
        field.question_type === "checkbox"
          ? values[field.name]
            ? "Yes"
            : "No"
          : values[field.name] || "",
    }));
